export default __webpack_public_path__ + "static/media/blog-1.b84c9245.jpg";